export function checkDeadline(d1: Date, d2: Date): boolean {
  return (
    d1.getMonth() === d2.getMonth() &&
    d1.getFullYear() === d2.getFullYear() &&
    d1.getDate() - d2.getDate() <= 2
  )
}
